import { IJsonSerializable } from '../util/interfaces'
import { OpDescr } from '../core/op-descr'
import { OpImportPluginParam } from './op-import-plugin-param'

export class OpImportPlugin implements IJsonSerializable {
    public name: string
    public description: OpDescr
    public allowedFileExtension: string[]
    public type: number
    public workType: number
    public params: OpImportPluginParam[]

    constructor(opObj: any = null) {
        this.fromJSON(opObj)
    }

    public toString(): string {
        if (this.description != null) {
            return this.description.toString()
        }
        if (this.name.indexOf('\\') > -1 || this.name.indexOf('/') > -1) {
            return this.name.split('\\').pop().split('/').pop()
        }
        return this.name
    }

    
    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            this.name = opObj.Name
            this.description = opObj.Description ? new OpDescr(opObj.Description) : null
            this.allowedFileExtension = opObj.AllowedFileExtension
            this.type = opObj.Type ? opObj.Type : null
            this.workType = opObj.WorkType
            if (opObj.Params)
                this.params = opObj.Params.map(param => new OpImportPluginParam(param))
        }
    }

    public toJSON(compressed: boolean = false): any {
        return {
            Name: this.name,
            Description: this.description ? this.description.toJSON() : null,
            AllowedFileExtension: this.allowedFileExtension,
            Type: this.type,
            WorkType: this.workType,
            Params: this.params ? this.params.map(p => p.toJSON()) : null
        }
    }
}